import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BillingDetails  {
    _originalTypeClassName = "zvelton_Backoffice.BO.BillingDetails";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BillingDetails.translate = translateService;
}
this.Id = null;
this.Company = null;
this.Email = null;
this.AddressLine1 = null;
this.AddressLine2 = null;
this.City = null;
this.PostalCode = null;
this.CountryCode = null;
this.VAT = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Company:any;
Email:any;
AddressLine1:any;
AddressLine2:any;
City:any;
PostalCode:any;
CountryCode:any;
VAT:any;


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}